import i18n from './i18n';

// Rustine front tant que l'API (BART_URL/TOPIVO_URL) renvoie du texte français
// plutôt qu'un code d'erreur. A enrichir au fil de l'eau, fallback = message brut.
const KNOWN_MESSAGES: Array<{ match: RegExp; key: string }> = [];

export const mapApiError = (rawMessage?: string): string => {
    if (!rawMessage) {
        return i18n.t('common:errors.generic');
    }
    const found = KNOWN_MESSAGES.find((k) => k.match.test(rawMessage));
    return found ? i18n.t(found.key) : rawMessage;
};
